import { EventEmitter, Injectable } from "@angular/core";
import { ApplicationLogDetailsRequest, ApplicationLogStepRequest, Step } from "leia-api";
import StateEnum = Step.StateEnum;
import NameEnum = Step.NameEnum;
import { MatDialog } from "@angular/material/dialog";
import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { SuggestedAddressComponent, SuggestedAddressDialogData, SuggestedAddressResponse } from "src/app/signup/suggested-address/suggested-address.component";
import { UtilitiesService } from "src/app/shared/services/utilities.service";
import OnboardingStepEnum = ApplicationLogStepRequest.OnboardingStepEnum;
import OnboardingStateEnum = ApplicationLogStepRequest.OnboardingStateEnum;
import OnboardingSourceEnum = ApplicationLogDetailsRequest.OnboardingSourceEnum;
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AddressVerificationService {
  public addressVerificationComplete = new EventEmitter<SuggestedAddressResponse>();
  public popupAction: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor (
    private _facade: FacadeService,
    private _dialog: MatDialog,
    private _utils: UtilitiesService
  ) {}

  public verifyAddress(applicantId: number): void {
    const applicationRequest = this._facade.getShoppingCartApplicationLogsRequest();
    const applicant = Array.from(applicationRequest.applicants ?? []).find((applicant: any) => applicant.applicantId === applicantId);

    if (!applicant) {
      this.addressVerificationComplete.emit();
      return;
    }

    const {
      streetAddress, streetAddress1, city, state, zip
    } = applicant.addresses![0];

    this._facade.addressVerify({
      streetAddress,
      streetAddress1,
      city,
      state: state,
      zip
    }).subscribe(async uspsAddress => {
      if (!uspsAddress.corrected) {
        this.addressVerificationComplete.emit();
        return;
      }

      const log = this._utils.createLog("SKH", `Address suggestion found: ${JSON.stringify(uspsAddress)}`);
      const step = this._utils.createStep(NameEnum.TellUsAboutYourself, StateEnum.Success, [log]);

      let applicationLogStepRequest = this._utils.createApplicationLogStepRequest(OnboardingStepEnum.TellUsAboutYourself, OnboardingStateEnum.Success, OnboardingSourceEnum.Bb8, [this._utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Skyhopper, `Address suggestion found: ${JSON.stringify(uspsAddress)}`)]);

      applicationRequest.step = step;
      applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

      this._facade.setShoppingCartApplicationLogsRequest(applicationRequest);
      await this._facade.updateApplication();

      const dialogData: SuggestedAddressDialogData = {
        applicantId,
        uspsAddress
      };

      this._dialog.open(SuggestedAddressComponent,{disableClose: true, data: dialogData}).afterClosed().subscribe(suggestedAddressResponse => {
        this.addressVerificationComplete.emit(suggestedAddressResponse);
      });
    }, async error => {
      const applicationRequest = this._facade.getShoppingCartApplicationLogsRequest();
      const log = this._utils.createLog("SKH", `Service call failed: ${JSON.stringify(error)}`);
      const step = this._utils.createStep(NameEnum.TellUsAboutYourself, StateEnum.Fail, [log]);

      let applicationLogStepRequest = this._utils.createApplicationLogStepRequest(OnboardingStepEnum.TellUsAboutYourself, OnboardingStateEnum.Fail, OnboardingSourceEnum.Bb8,[this._utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Skyhopper, `Service call failed: ${JSON.stringify(error)}`)]);

      applicationRequest.step = step;
      applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

      this._facade.setShoppingCartApplicationLogsRequest(applicationRequest);
      await this._facade.updateApplication();

      this.addressVerificationComplete.emit();
    });
  }
}

